import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";
import {FaUsers} from "react-icons/fa";

const GroupCard = ({data}) => {
  const {name = "", total_user_count = ""} = data;

  return (
    <CardBody>
      <CardTitle tag="h3">Name: {name}</CardTitle>
      <CardText>
        <FaUsers aria-hidden="true" /> {total_user_count}
      </CardText>
    </CardBody>
  );
};

export default GroupCard;
